import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-bar-one', 'ChartBarOne', [["path",{"d":"M18 8v13M12 3v18m-6-9v9","key":"svg-0"}]]);